import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { FaWaveSquare } from "react-icons/fa";

import Page from 'src/components/Page';
import api from '../../services/api';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Message from './Message';
import Field from './Field';
import Test from './Test';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  _id: '',
  code: '',
  inputs: [],
  outputs: []
}

const defaultField = {
  _id: '',
  order: 0,
  name: '',
  unit: '',
  format: '',
  sufix: '',
  tests: []
}

const defaultDependencies = {
  loaded: false,
  hardwares: [],
  firmwares: []
}

const defaultTestItem = {
  _id: '',
  monitor: '',
  condition: '',
  operator1: '',
  operator2: '',
  value1: 0,
  value2: 0,
  result: '',
  type: '',
  enabled: true
};

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Código', field: 'item.code', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Nome', field: 'item.name', size: -1, sortable: 'name', exportable: 0, wrap: 1 },
  { name: 'Criação', field: 'formatDate(item.createdAt)', size: -1, sortable: 'createdAt', exportable: 0, wrap: 1 }
];

const defaultEmptyMessage = "Nenhum Protocolo de Comunicação com Dispositivos Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_DISABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_DISABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Mensagem pelo Código', refine: 1, label: 'Descrição do Dispositivo', history: 0 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Messages = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const [openFieldEditionDialog, setOpenFieldEditionDialog] = useState(false);
  const [openFieldDeletionDialog, setOpenFieldDeletionDialog] = useState(false);
  const [field, setField] = useState(defaultField);

  const [openTestEditionDialog, setOpenTestEditionDialog] = useState(false);
  const [openTestDeletionDialog, setOpenTestDeletionDialog] = useState(false);
  const [test, setTest] = useState(defaultTestItem);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    setField(item);
    setOpenEditionDialog(true);
  }

  const openCreation = async (item) => {
    setItem(item);
    setOpenCreationDialog(true);
  }

  const openDeletion = async (item) => {
    setItem(item);
    setMessage({
      title: 'Protocolo',
      message: 'Deseja excluir o protocolo selecionado?',
      warn: 'Esta ação irá interferir no recebimento de eventos.',
      details: ['Não será possível recuperar o protocolo excluido. Todos os processos relacionado a eventos apresentarão falha.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    api.put('/messages/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
        closeFieldEdition();
        closeTestEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao atualizar protocolo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    api.post('/messages', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar protocolo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {

  };

  const deleteValues = (values) => {
    api.delete('/messages/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover protocolo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    api.get('/messages', {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de protocolos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows, message) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision,
      message: message
    };
    setVision(vision);
    setFilter(value);
    setItem(message);
    setState({
      loaded: true,
      pages: ((message) ? 1 : 0),
      page: ((message) ? 1 : 0),
      count: ((message) ? 1 : 0),
      rows: ((message) ? [message] : [])
    });
  }

  const refreshItems = () => {
    setState({
      loaded: true,
      pages: ((message) ? 1 : 0),
      page: ((message) ? 1 : 0),
      count: ((message) ? 1 : 0),
      rows: ((message) ? [message] : [])
    });
  }

  const closeFieldDeletion = () => {
    setOpenFieldDeletionDialog(false);
  };

  const closeFieldEdition = () => {
    setOpenFieldEditionDialog(false);
  };

  const closeTestDeletion = () => {
    setOpenTestDeletionDialog(false);
  };

  const closeTestEdition = () => {
    setOpenTestEditionDialog(false);
  };

  const openFieldEdition = (field) => {
    setField(field)
    setOpenFieldEditionDialog(true);
  };

  const deleteTestValues = (values) => {
    var tests = [];
    field.tests.map((testvalue, index) => {
      if (testvalue._id != values._id) {
        tests.push(testvalue);
      }
    })
    field.tests = tests;
    closeTestDeletion();
  };

  const updateTestValues = (values) => {
    field.tests.push(values);
    field.tests.map((testvalue, index) => {
      if (testvalue._id === values._id) {
        field.tests[index].name = values.monitor;
        field.tests[index].description = values.condition;
        field.tests[index].rule.event.params.msg = values.result;
        field.tests[index].enabled = values.enabled;
        field.tests[index].rule.conditions.all[0].operator = values.operator1;
        field.tests[index].rule.conditions.all[0].value = values.value1;
        if (values.operator2 != '' && values.value2 != '') {
          if (field.tests[index].rule.conditions.all.length === 2) {
            field.tests[index].rule.conditions.all[1].operator = values.operator2;
            field.tests[index].rule.conditions.all[1].value = values.value2;
          } else {
            field.tests[index].rule.conditions.all.push({ operator: values.operator2, value: values.value2, fact: 'value' })
          }
        }

        api.put('/tests/' + field.tests[index]._id, field.tests[index]).then((response) => {
          setMessage(response.data);
          setOpenAlert(true);
          if (!response.data.error) {
            closeTestEdition();
          }
        }).catch((error) => {
          console.error(error);
        })
      }
    })
  };

  const updateFieldValues = (values) => {
    if (item._id) {
      item.inputs.map((fieldvalue, index) => {
        if (fieldvalue._id === values._id) {
          //item.inputs[index] = values;
        }
      })
      api.put('/messages/' + item._id, item).then((response) => {
        if (!response.data.error) {
          refreshItems();
          closeEdition();
          closeFieldEdition();
        }
        setMessage(response.data);
        setOpenAlert(true);
      }).catch((error) => {
        console.error(error);
      })
    } else {
      createValues(values);
    }
  };

  const openFieldDeletion = (field) => {
    setField(field)
    setMessage({
      title: 'Entrada de Dispositivo',
      message: 'Deseja excluir o entrada de dispositivo "' + field.name + '" do "Protocolo ' + item.code + '"?',
      warn: ['A exclusão do campo selecionado pode acarretar erro no recebimento de dados dos disposívos.']
    });
    setOpenFieldDeletionDialog(true);
  };

  const openTestEdition = (test) => {
    if (test._id != '') {
      var value = {
        _id: test._id,
        monitor: test.name,
        condition: test.description,
        operator1: ((test.rule.conditions.all.length >= 1) ? (test.rule.conditions.all[0].operator) : ('')),
        operator2: ((test.rule.conditions.all.length >= 2) ? (test.rule.conditions.all[1].operator) : ('')),
        value1: ((test.rule.conditions.all.length >= 1) ? (test.rule.conditions.all[0].value) : ('')),
        value2: ((test.rule.conditions.all.length >= 2) ? (test.rule.conditions.all[1].value) : ('')),
        result: test.rule.event.params.msg,
        enabled: test.enabled
      }
      setTest(value);
    } else {
      setTest(test);
    }
    setOpenTestEditionDialog(true);
  };

  const openTestDeletion = (test) => {
    setTest(test)
    setMessage({
      title: 'Monitor',
      message: 'Deseja excluir o monitor "' + test.description + '" da "Entrada de Dispositivo ' + field.name + '"?',
      warn: ['A exclusão do monitor selecionado irá cancelar a geração de alarmes e gráficos para essa entrada de dispositivo.']
    });
    setOpenTestDeletionDialog(true);
  };

  return (
    <Page
      className={classes.root}
      title="Protocolo de Dispositivo"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={FaWaveSquare}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openFieldDeletionDialog}
          close={closeFieldDeletion}
          confirmation={updateFieldValues} />

        <Confirmations item={test}
          message={message}
          open={openTestDeletionDialog}
          close={closeTestDeletion}
          confirmation={deleteTestValues} />

        <Message item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Field
          item={field}
          open={openFieldEditionDialog}
          closeEdition={closeFieldEdition}
          updateValues={updateFieldValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          openTestEdition={openTestEdition}
          openTestDeletion={openTestDeletion}
          test={defaultTestItem}
        />

        <Test
          item={test}
          open={openTestEditionDialog}
          closeEdition={closeTestEdition}
          updateValues={updateTestValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          field={field}
        />

        <Box mt={3}>
          <Results
            resultSet={state}
            resultModes={resultModes}
            icon={FaWaveSquare}
            vision={vision}
            selectedMode={selectedMode}
            openEdition={openEdition}
            openDeletion={openDeletion}
            openTreatment={openTreatment}
            openExportDialog={openExportDialog}
            changeSort={changeSort}
            openFieldEdition={openFieldEdition}
          />
        </Box>

      </Container>
    </Page>
  );
};

export default Messages;